// Spec 000306 - must match DriverSecurityErrorEnum on the server.
const driverSecurityErrorEnum = {
  DriverSessionRequired: -101,
  DriverSessionMismatch: -102,
  CodeMismatch: -103,
  CodeBurned: -104,
  CodeExpired: -105,
  ResendTooSoon: -106,
  ResendLimit: -107,
  LoginLimit: -108,
  SessionNotOpen: -109,
  ReadOnlyLink: -110,
  LinkExpired: -111,
};

export default driverSecurityErrorEnum;
